var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box"},[_c('fa',{staticClass:"info-box__btn",attrs:{"icon":['fa', 'info-circle']}}),_c('div',{staticClass:"info-box__modal"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }